module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.10307/js/img/CommerceHub_Icon.svg"